import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
type DefaultType = 'configuration' | 'ruleset';

@Component({
	selector: 'app-non-defaults-dialog-box',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './non-defaults-dialog-box.component.html',
	styleUrl: './non-defaults-dialog-box.component.scss'
})
export class NonDefaultsDialogBoxComponent {

	
	constructor(
		private dialogRef: MatDialogRef<NonDefaultsDialogBoxComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: { type: DefaultType }
	) { }


	confirm(): void {
		this.dialogRef.close(true);
	}


	cancel(): void {
		this.dialogRef.close(false);
	}
}
